<template>
  <div class="container-fluid">
    <personal-info
      @updateCredentials="updateCredentials"
      @changePassword="changePassword"
      :loading="loading.personalInfo"
      :credentials="credentials"
    />
    <employees
      v-if="phoneMask && (credentials.type === 1 || credentials.soleProprietor)"
      :phoneMask="phoneMask"
    />
    <notifications
      :data="notifications"
      :loading="loading.notifications"
      v-if="notifications.length"
      @updateNotifications="updateNotifications"
    />

  </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import PersonalInfo from './PersonalInfo'
import Employees from './Employees'
import Notifications from './Notifications'

export default {
  name: 'Profile',
  components: {
    'personal-info': PersonalInfo,
    'employees': Employees,
    'notifications': Notifications
  },
  data() {
    return {
      credentials: null,
      employees: null,
      notifications: [],
      loading: {
        personalInfo: false,
        companyDefails: false,
        employees: false,
        notifications: false
      },
      error: ''
    }
  },
  computed: {
    ...mapState({
      phoneMask: state => state.config.data.phoneMask,
      allowPasswordChange: state => state.config.data.allowPasswordChange
    })
  },
  methods: {
    getCredentials: function() {
      this.loading.credentials = true
      axios.get('profile').then(promise => {
        this.credentials = promise.data.results
        this.loading.credentials = false
      }).catch(error => {
        console.log(error.response.data.error)
        this.loading.credentials = false
      })
    },
    updateCredentials: function() {
      axios.put('profile/' + this.credentials.uid, {
        ...this.credentials
      })
        .then(promise => {
          this.loading.personalInfo = false
          this.$notify(
            {
              message: this.$t('Profile updated'),
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'success'
            })
        })
        .catch(error => {
          this.loading.personalInfo = false
          this.$notify(
            {
              message: error.response.data.error,
              horizontalAlign: 'center',
              verticalAlign: 'top',
              type: 'danger'
            })
        })
    },
    changePassword: function(params) {
      axios.post('profile/changePassword', {
        'oldPassword': params.currentPassword,
        'confirmedPassword': params.confirmedPassword
      }).then(promise => {
        this.$notify(
          {
            message: this.$t('Password updated'),
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })
      }).catch(error => {
        console.log(error.response)
        this.$notify(
          {
            message: error.response.data.error,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
      })
    },
    getNotifications: function() {
      this.loading.notifications = true
      axios.get('notifications').then(promise => {
        this.notifications = promise.data.results
        this.loading.notifications = false
      }).catch(error => {
        console.log(error.response.data.error)
        this.loading.notifications = false
      })
    },
    updateNotifications: function() {
      this.loading.notifications = true
      axios.post('notifications/update', {
        notifications: this.notifications
      }).then(promise => {
        this.loading.notifications = false
        this.$notify(
          {
            message: this.$t('Notifications saved'),
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'success'
          })
      }).catch(error => {
        console.log(error.response.data.error)
        this.loading.notifications = false
        this.$notify(
          {
            message: error.response.data.error,
            horizontalAlign: 'center',
            verticalAlign: 'top',
            type: 'danger'
          })
      })
    }
  },
  mounted() {
    this.getCredentials()
    this.getNotifications()
  }
}
</script>

<style>

</style>
